<template>
    <b-modal
            :visible="show"
            @hidden="hideEvents"
            title="Assign client actions"
            :id="modalId"
    >
        <vue-element-loading :active="loading" :is-full-screen="false"/>

        <b-form>
            <b-form-group
                    label="Assign to user or team"
            >
                <multiselect
                        v-if="!loading"
                        :options="form.reviewer.options"
                        label="label"
                        v-model="form.reviewer.value"
                        group-label="team"
                        group-values="items"
                        :group-select="false"
                        selectLabel=""
                        placeholder=""
                        tagPlaceholder=" "
                        deselectLabel=""
                >
                    <template #caret="{ toggle }">
                        <caret-icon @mousedown.prevent.stop="toggle"></caret-icon>
                    </template>
                </multiselect>
            </b-form-group>
        </b-form>

        <confirmation-warning
                v-if="showUnlockButton"
                :numberOfItems="this.nodeIds.length"
                @unlocked="unlocked = true">
        </confirmation-warning>

        <template slot="modal-footer">
            <b-button
                    variant="outline-secondary"
                    @click="hideModal">
                Cancel
                <font-awesome-icon
                        :icon="['far', 'times']">
                </font-awesome-icon>
            </b-button>
            <b-button
                    class="btn-arrow"
                    variant="primary"
                    @click="assignActions"
                    :disabled="assignDisabled"
            >
                Assign items
                <font-awesome-icon
                        :icon="['far', 'arrow-right']">
                </font-awesome-icon>
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import CaretIcon from '@/components/Form/CaretIcon';
import ModalMixin from '@/components/Modal/ModalMixin';
import DatePicker from '@/components/Form/DatePicker';
import ConfirmationWarning from '@/components/Notifications/ConfirmationWarning';
import dayjs from 'dayjs';
import ClientActionAssign from '../../../services/Action/ClientActionAssign';
import ActionAssign from '@/services/Action/ActionAssign';

export default {
  name: 'Client-Action-Assign-Modal',
  components: {
    CaretIcon,
    DatePicker,
    ConfirmationWarning,
  },
  mixins: [ModalMixin],
  data() {
    return {
      modalId: 'clientActionAssignModal',
      loading: false,
      unlocked: false,
      unlockIcon: false,
      maxNumberOfSelectedActions: 300,
      form: {
        reviewer: {
          value: [],
          options: [],
        },
      },
    };
  },
  computed: {
    assignDisabled() {
      return !this.validate() || this.loading;
    },
    requiresApproval() {
      return this.nodeIds.length > this.maxNumberOfSelectedActions;
    },
    showUnlockButton() {
      return this.requiresApproval && this.form.reviewer.value.length !== 0;
    },
  },
  watch: {
  },
  created() {
    this.getAssignOptions();
  },
  methods: {
    async getAssignOptions() {
      this.loading = true;
      ActionAssign.getFormattedOptions().then((options) => {
        this.form.reviewer.options = options;
        this.loading = false;
      });
    },

    async assignActions() {
      if (!this.validate()) {
        return;
      }

      this.loading = true;

      const { teamId, userId } = this.form.reviewer.value;
      const clientActionIds = this.nodeIds;

      const params = {
        clientActionIds,
        teamId,
        userId,
      };

      try {
        const response = await ClientActionAssign.assign(params);
        const { result, data } = response.data;
        const { success, failed } = data;

        const title = 'Client actions assigned';
        let text = `${success} client actions have been successfully assigned.`;
        let type = 'success';

        if (failed > 0 || !result) {
          type = 'warn';
          text += ` ${failed} client actions failed to be assigned. Please check your email for more information.`;
        }

        this.$notify({
          duration: 7000,
          title,
          text,
          type,
        });
        this.$store.dispatch('refreshActions');
      } catch (e) {
        this.$notify({
          title: 'Error',
          text: 'Something went wrong. Please try again later.',
          type: 'error',
        });
      } finally {
        this.hideModal();
        this.loading = false;
      }
    },

    validate() {
      if (this.form.reviewer.value.length === 0
          || this.nodeIds.length === 0
          || (this.requiresApproval && !this.unlocked)
      ) {
        return false;
      }

      return true;
    },

    hideModalEvents() {
      this.form.reviewer.value = [];
      this.form.internalDueDate = '';
    },
  },
};
</script>

<style lang="scss">
    .modal {
        form {
            min-height: 238px;
        }
        .btn.btn-arrow {
            min-width: 140px;
        }

        .btn-outline-secondary + .btn-arrow {
            margin: auto;
            margin-right: 0;
        }
    }
</style>
